/** Oculta visualmente pero deja el contenido disponible para lectores de pantalla y buscadores. */
export const visuallyHiddenSx = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;

/**
 * Copias de un carrusel en loop: fuera del árbol de accesibilidad y sin foco.
 * `inert` va como atributo crudo porque React 18 no lo tipa.
 */
export const cloneSlideProps = (isClone: boolean) =>
  isClone ? { 'aria-hidden': true as const, inert: '' } : {};

/** En un track [cola clonada][ítems][cabeza clonada], indica si la posición es una copia. */
export const isLoopClone = (trackIndex: number, itemCount: number, windowSize: number) =>
  trackIndex < windowSize || trackIndex >= windowSize + itemCount;
